import { CqmAmcDashboardDto, CqmAmcInventoryDto, MipsPiDashboard } from '@medone/medonehp-api-client';

// Re-export the generated enum + DTOs the rest of the feature needs so components stay
// decoupled from the generated package's name (same pattern as models.ts).
export { CqmEngineBinding } from '@medone/medonehp-api-client';

export type { CqmAmcDashboardDto, CqmAmcDashboardMeasureDto, CqmAmcInventoryDto, CqmAmcInventoryMeasureDto, CqmAmcRecomputeReceiptDto, MipsPiDashboard, MipsPiDashboardRow } from '@medone/medonehp-api-client';

// Mirrors Backend CqmRecomputeTriggers.AdminRecompute — the only trigger the UI sends;
// the generated client exposes no constant/enum for it (plain string on the request dto).
export const AdminRecomputeTrigger = 'AdminRecompute';

export interface AmcState {
    // Per-fetch flags: inventory (slow measure-binding probe) and dashboard load in parallel,
    // so a shared flag would be cleared by whichever finishes first.
    inventoryLoading: boolean;
    dashboardLoading: boolean;
    recomputing: boolean;
    errorMessage: string | null;
    inventory: CqmAmcInventoryDto | null;
    dashboard: CqmAmcDashboardDto | null;
    // (g)(2) Promoting Interoperability measures. Their own flag and payload: they are a different
    // program with a different shape (no IPP/DENEX, one row per clinician and per TIN) and they load
    // over a date range rather than a measure year.
    piLoading: boolean;
    pi: MipsPiDashboard | null;
}

export const initialAmcState: AmcState = {
    inventoryLoading: false,
    dashboardLoading: false,
    recomputing: false,
    errorMessage: null,
    inventory: null,
    dashboard: null,
    piLoading: false,
    pi: null,
};
